// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__caZIt","requiredAsterisk":"Info_requiredAsterisk__4XZYn"};